import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import DropDown from '../ui/react-ui/dropdown';
import Progress from '../ui/react-ui/progress.jsx';
import MapeTerminalChart from './mape-terminal-chart'; // api

import { getMapeZoneVisitByWeek } from '../../api/mapeAPI'; // redux

import { setTerminalId, setTerminalsMapeByWeek } from '../../redux/setting-mape';
var t = i18n.getFixedT(null, 'setting-mape');
var MapeTerminal = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$mape = _useSelector.mape,
      dateRange = _useSelector$mape.dateRange,
      terminalsMapeData = _useSelector$mape.terminalsMapeData,
      terminalId = _useSelector$mape.terminalId,
      _useSelector$app = _useSelector.app,
      zonesList = _useSelector$app.zonesList,
      terminalsList = _useSelector$app.terminalsList;

  var dispatch = useDispatch();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      zoneTerminalMapeData = _useState2[0],
      setZoneTerminalMapeData = _useState2[1];

  var isMounted = useRef(false);
  var id = props.id,
      predictionType = props.predictionType;

  var handleDropDownChange = function handleDropDownChange(val) {
    dispatch(setTerminalId(val));
  };

  var renderTr = function renderTr() {
    var trDoms = [];
    zoneTerminalMapeData.map(function (el) {
      trDoms.push(_.map(el.terminalList, function (o, index) {
        return /*#__PURE__*/React.createElement("tr", {
          key: o.terminalId + index
        }, index === 0 && /*#__PURE__*/React.createElement("td", {
          rowspan: el.terminalList.length
        }, el.text), /*#__PURE__*/React.createElement("td", null, o.terminalName), /*#__PURE__*/React.createElement("td", {
          className: parseInt(o.mape) > 20 ? 'high' : ''
        }, o.mape ? o.mape + '%' : ''));
      }));
    });
    return trDoms;
  };

  useEffect(function () {
    if (!isMounted.current) return;
    getMapeZoneVisitByWeek(contextRoot, false, dateRange, predictionType, terminalId).then(function (result) {
      var mapeZoneByWeek = _.cloneDeep(result.content).sort(function (a, b) {
        return a.day - b.day;
      });

      mapeZoneByWeek.unshift(mapeZoneByWeek.pop());
      dispatch(setTerminalsMapeByWeek(mapeZoneByWeek));
    });
  }, [terminalId]);
  useEffect(function () {
    if (!isMounted.current) return;

    var newData = _.cloneDeep(zonesList.sort(function (a, b) {
      return a.value > b.value ? 1 : -1;
    }));

    _.map(terminalsList, function (el) {
      var zoneData = _.find(newData, function (o) {
        return o.value === el.zoneId;
      });

      var mapeData = _.find(terminalsMapeData, function (o) {
        return o.terminalId === el.value;
      });

      if (!zoneData.terminalList) zoneData.terminalList = [];
      zoneData.terminalList.push({
        terminalName: el.text,
        mape: mapeData && mapeData.mape ? Math.round(mapeData.mape * 100 * 10) / 10 : ''
      });
    });

    setZoneTerminalMapeData(newData);
  }, [JSON.stringify(terminalsMapeData), JSON.stringify(zonesList), JSON.stringify(terminalsList)]);
  useEffect(function () {
    if (!isMounted.current) {
      // init
      var newData = _.cloneDeep(zonesList.sort(function (a, b) {
        return a.value > b.value ? 1 : -1;
      }));

      _.map(terminalsList, function (el) {
        var zoneData = _.find(newData, function (o) {
          return o.value === el.zoneId;
        });

        var mapeData = _.find(terminalsMapeData, function (o) {
          return o.terminalId === el.value;
        });

        if (!zoneData.terminalList) zoneData.terminalList = [];
        zoneData.terminalList.push({
          terminalName: el.text,
          mape: mapeData && mapeData.mape ? Math.round(mapeData.mape * 100 * 10) / 10 : ''
        });
      });

      setZoneTerminalMapeData(newData);
      isMounted.current = true;
    }

    return function () {
      setZoneTerminalMapeData([]);
    };
  }, []);
  if (!isMounted.current) return null;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "mape-card-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-terminal-time-model')), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-terminal'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-terminals'),
    list: terminalsList,
    value: terminalId,
    onChange: function onChange(val) {
      return handleDropDownChange(val);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("table", {
    className: "mape-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    colspan: "2"
  }, t('lbl-model')), /*#__PURE__*/React.createElement("th", {
    rowspan: "2"
  }, t('lbl-mape'))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t('lbl-terminal-center')), /*#__PURE__*/React.createElement("th", null, t('lbl-terminal')))), /*#__PURE__*/React.createElement("tbody", null, renderTr())), /*#__PURE__*/React.createElement(MapeTerminalChart, null)));
});
MapeTerminal.defaultProps = {
  id: 'g-mape-terminal'
};
MapeTerminal.PropTypes = {
  id: PropTypes.string
};
export default MapeTerminal;